import { render, staticRenderFns } from "./MaterialInformation.vue?vue&type=template&id=5131d711&scoped=true"
import script from "./MaterialInformation.vue?vue&type=script&lang=js"
export * from "./MaterialInformation.vue?vue&type=script&lang=js"
import style0 from "./MaterialInformation.vue?vue&type=style&index=0&id=5131d711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131d711",
  null
  
)

export default component.exports